import {BaseDomainService} from "../../../infrastructure/domain-services/base-domain-service";
import {CompetitorsResponseApiModel} from "../models/competitors.response-api-model";
import {CompetitionDomainModel} from "../../common/competition/models/competition-domain-model";
import {SportApiModel} from "../../sports/models/sport-api-model";
import {CompetitionApiModel} from "../../common/competition/models/competition-api-model";
import {CountryApiModel} from "../../common/country/models/country-api-model";
import {SportsFactory} from "../../sports/domain-services/sports.factory";
import {CompetitorsFactory} from "./competitors.factory";
import {CompetitorsRepository} from "./competitors.repository";
import {CountryFactory} from "../../common/country/domain-services/country-factory";
import {CompetitionFactory} from "../../common/competition/domain-services/competition-factory";
import {CompetitorFactory} from "../../common/competitor/domain-services/competitor-factory";
import {CompetitorApiModel} from "../../common/competitor/models/competitor-api-model";
import {CompetitorCompetitionsDomainModel} from "../../common/competitor/models/competitor-competitions.domain-model";
import {BaseManagedService} from "../../../infrastructure/domain-services/base-managed-service";
import {DomainRequestManager} from "../../../core/managers/domain-request-manager";
import {DomUtils} from "../../../infrastructure/utils/dom-utils";
import {LoggerUtils} from "../../../infrastructure/utils/logger/logger-utils";
import {SiteConfig} from "../../../core/bootstrap/models/site-config";
import {DeviceStore} from "../../../core/app/device.store";
import {AppStore} from "../../../core/app/app-store";
import {NavigationManager} from "../../../core/managers/navigation-manager";
import {HistoryManager} from "../../../core/managers/history-manager";
import {LocalStorageUtils} from "../../../infrastructure/utils/local-storage.utils";
import {contractsUtils} from "../../../infrastructure/utils/contracts-utils";
import {SportDomainModel} from "../../sports/models/sport-domain-model";

export class CompetitorsDomainService extends BaseDomainService {
  factory: CompetitorsFactory;
  sportFactory: SportsFactory;
  countryFactory: CountryFactory;
  competitionFactory: CompetitionFactory;
  competitorFactory: CompetitorFactory;

  static injectables = [...BaseManagedService.injectables, CompetitorsRepository, CompetitorsFactory, DomainRequestManager, CompetitionFactory, SportsFactory, CountryFactory, CompetitorFactory];

  constructor(
    domUtils: DomUtils,
    logger: LoggerUtils,
    siteConfig: SiteConfig,
    deviceStore: DeviceStore,
    appStore: AppStore,
    navigationManager: NavigationManager,
    historyManager: HistoryManager,
    localStorageUtils: LocalStorageUtils,
    competitorsRepository: CompetitorsRepository,
    competitorsFactory: CompetitorsFactory,
    requestManager: DomainRequestManager,
    competitionFactory: CompetitionFactory,
    sportFactory: SportsFactory,
    countryFactory: CountryFactory,
    competitorFactory: CompetitorFactory
  ) {
    super(
      domUtils,
      logger,
      siteConfig,
      deviceStore,
      appStore,
      navigationManager,
      historyManager,
      localStorageUtils,
      competitorsRepository,
      competitorsFactory,
      requestManager,
    );

    contractsUtils.requiredType(competitionFactory, CompetitionFactory);
    contractsUtils.requiredType(sportFactory, SportsFactory);
    contractsUtils.requiredType(countryFactory, CountryFactory);
    contractsUtils.requiredType(competitorFactory, CompetitorFactory);

    this.sportFactory = sportFactory;
    this.countryFactory = countryFactory;
    this.competitionFactory = competitionFactory;
    this.competitorFactory = competitorFactory;
  }


  populateResponse(competitorsResponseApiModel: CompetitorsResponseApiModel) {
    if (!competitorsResponseApiModel) {
      return null;
    }

    const countriesDomainModelByCountryId = {};
    const sportsDomainModelBySportId = {};

    competitorsResponseApiModel.countries?.forEach((country: CountryApiModel) => {
      countriesDomainModelByCountryId[country.id] = this.countryFactory.createDomainModel(country);
    });

    competitorsResponseApiModel.sports?.forEach((sport: SportApiModel) => {
      sportsDomainModelBySportId[sport.id] = new SportDomainModel(sport);
    });

    const competitionsDomainModel: Array<CompetitionDomainModel> = (competitorsResponseApiModel.competitions || []).map((competition: CompetitionApiModel) => {
      return this.competitionFactory.createDomainModel(competition, countriesDomainModelByCountryId[competition.countryId], sportsDomainModelBySportId[competition.sportId]);
    });

    const competitorsCompetitionsDomainModel: Array<CompetitorCompetitionsDomainModel> = (competitorsResponseApiModel.competitors || []).map((competitorApiModel: CompetitorApiModel) => {
      const filteredCompetitionsDomainModel = competitionsDomainModel.filter((competitionDomainModel: CompetitionDomainModel) => {
        return competitorApiModel.competitions?.includes(competitionDomainModel.id);
      });
      const competitorCompetitionsDomainModel = this.factory.createCompetitorCompetitionsDomainModel(competitorApiModel, countriesDomainModelByCountryId[competitorApiModel.countryId], sportsDomainModelBySportId[competitorApiModel.sportId], filteredCompetitionsDomainModel);

      return competitorCompetitionsDomainModel;
    });

    return this.factory.createDomainModel(competitorsCompetitionsDomainModel, competitionsDomainModel);
  }
}
